import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ref } from '@dbk-legacy/muster/utils';
import filter from 'lodash/fp/filter';
import update from 'lodash/fp/update';
import remove from 'lodash/remove';
import find from 'lodash/find';
import concat from 'lodash/concat';
import Text from '@dbk/ui-text';
import ToastFullLength from '../../toast-full-length';
import { createContainer } from '@dbk-legacy/muster/react';
import BackLink from '../../../components/common/back-link';
import PortfolioSelector from '../../../components/common/portfolio-selector';
import BeneficiaryAddressBanner from '../../../components/common/beneficiary-address-banner';


class AppHeader extends PureComponent {
  constructor(props) {
    super(props);
    // this.filterPortfolioList = this.filterPortfolioList.bind(this);
    this.getSelectedPortfolioIndex = this.getSelectedPortfolioIndex.bind(this);
    this.handlePortfolioPress = this.handlePortfolioPress.bind(this);
  }

  async handlePortfolioPress(portfolio) {
  const { app: { user }, search, changePage, replacePage, ui: { history }, userprofile: {setPrefCurrency} }= this.props;
    setPrefCurrency(undefined);
    await this.props.clearData();
    user.setSelectedPortfolioId(portfolio.id);
    user.setSelectedPortfolioData(portfolio);
    user.setSelectedPortfolio(portfolio);
    search.clearSearchFilters();
  
  if(history.currentLocation.pathname.endsWith('/portfolios')){
      changePage('/loadingview');
      changePage('/portfolios');
    } 
      
  if(history.currentLocation.pathname.includes('/genericAssets')){
        // WMCE-18515 -Web - Pagination not getting when user switching the portfolio on Asset page   
        this.props.portfolio.genericAssets.positions.setPageOffset(0);
        this.props.ui.state.portfolio.genericAssets.resetSort();
        changePage('/portfolios')
    }
  }

  filterPortfolioList = (portfolios) => {
    const singles = filter({ relId: null }, portfolios);
    const consolidates = filter((p) => p.relId !== null, portfolios);

    const uniqueConsolidates = [];
    consolidates.forEach((p, index) => {
      const found = find(uniqueConsolidates, { relId: p.relId });
      !found && uniqueConsolidates.push(p);
    });
    return concat(singles, uniqueConsolidates);
  };

  getSelectedPortfolioIndex(portfolios) {
    const { app: { user } } = this.props;
    const p = user.selectedPortfolioData || user.selectedPortfolio;
    const key = p.relId ? 'relId' : 'id';
    return portfolios.findIndex((e) => e[key] === p[key]);
    // const foundIndex = findIndex(portfolios, p => portfolio.relId ?
    //     p.relId === portfolio.relId
    //     : p.id === portfolio.id);
    // return foundIndex >= 0 ? foundIndex + 1 : 0;
  }

  /**
   * function to remove toastObj from toastMsg array
   */
  removeToast = (msg, index) => {
    const { ui: { toastMsg }, setToastMsg } = this.props;
    const messages = toastMsg;
    if (index > -1) {
      messages.splice(index, 1);
      setToastMsg(null);
    }
    setToastMsg(messages);
  }
  componentDidUpdate(){
    if(document.querySelector('.heading-container')){ 
      document.querySelector('.heading-container').focus();
    }
  }

  render() {
    const {
      ui: { history, toastMsg },
      app: { user },
      rsa,
      vascoauthentication,
      search,
      reports: { hideDWOPortfolioSelector },
      i18n: { messages },
      alerts : { isAvaloqDown },
    } = this.props;
    const pathLocation = history.currentLocation.pathname;
    const isDashboardPage = pathLocation.includes('dashboard');
    //const showOrHideHeader = pathLocation.includes('insights');
    const showOrHidePortfolio = pathLocation.includes('payment') || pathLocation.includes('profile') || pathLocation.includes('investments') || pathLocation.includes('trade-library') || pathLocation.includes('psd2') ||
    pathLocation.includes('login-faq') || pathLocation.includes('login-security') || pathLocation.includes('adhoc-statement') || pathLocation.includes('cashAccountsMoreDetails');
    // console.log("this props : ", this.props)

    const screensArrayToHideHeader = ['/psd2/aisflow', '/reports/adhoc-statement/success'];
    if (hideDWOPortfolioSelector) {
      // screensArrayToHideHeader.push('reports');
      // screensArrayToHideHeader.push('transactions');
      // screensArrayToHideHeader.push('dataExports');

    }

    const showOrHideHeader = screensArrayToHideHeader.some((el) => pathLocation.includes(el));

    let portfolioElements = [],
      existflag = false;
    user.portfolios.map((portfolio) => {
      existflag = false;
      portfolioElements.map((portfolioEle) => {
        if (
          portfolioEle.id === portfolio.id &&
          portfolioEle.relId === portfolio.relId
        ) {
          existflag = true;
        }
      });
      if (!existflag) {
        portfolioElements.push(portfolio);
      }
    });

    const selectedPortfolio =
      user.selectedPortfolioData || user.selectedPortfolio;
    const parsedPortfolioList = portfolioElements; // removed filter 
    user.setPortfoliosData(parsedPortfolioList);
    search.setPortfolioIds(portfolioElements);
    // let customTitle = messages[ui.customtitle];
    // let headerTitle = messages[ui.title];
    let portfolioLength = parsedPortfolioList.length;

    return (
      <div>
        <div className="toast-container">
          {toastMsg && <ToastFullLength toastMsgs={toastMsg} onClose={this.removeToast} />}
        </div>
        <div className="app-header">
          {isDashboardPage && <BeneficiaryAddressBanner />}
          {/* <div className="app-top-bar">
            <div className="app-bar-container flex">
              <div className="title-box text-center flex-grow-1">
                <div id={customtitle || titleMsg} className="section-title ellipsis">
                  {customtitle || titleMsg}
                </div>
              </div>
            </div>
          </div> */}
          {/* include in below block : showOrHideHeader (!showOrHideHeader &&) to remove insights page */}
          {!showOrHideHeader && (
            <div className="portfolio-bar">
              <div className="portfolio-row">

                <div className="small-2 column text-left backBtnTopMargin">
                  <BackLink messages={messages} />
                </div>

                {!showOrHidePortfolio &&
                  <div className={ (isAvaloqDown && this.props.ais.isBannerVisible) ? "marginTop column text-right small-3 no-padding-left" : "column text-right small-3 no-padding-left" }>
                    <div id="dropdown_maturities_appHeader_test" className={`portfolio-box ${this.props.ais.isBannerVisible? 'opacityForBanner' : null}`}>
                    {portfolioLength > 1? <Text secondary={true} className="portfolio-index">
                        {messages['app.header.wigdet.selection.title']}
                      </Text>:
                      <Text secondary={true} className="portfolio-index">
                      Porfolio
                    </Text>}
                      <div className="portfolio-list-selector" id="dropdown_maturities_innerDiv_appHeader_test">
                        <PortfolioSelector
                          portfolios={parsedPortfolioList}
                          selectedPortfolio={selectedPortfolio}
                          onPortfolioSelect={this.handlePortfolioPress}
                          onRsaAuthorised={rsa.rsaAuthorised}
                          onVascoAuthorised={vascoauthentication.vascoAuthorised}
                          messages={messages}
                          logoutVisible={this.props.logoutPopup.isVisible}
                        />
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

AppHeader.propTypes = {
  title: PropTypes.string,
  changePage: PropTypes.func,
  replacePage: PropTypes.func,
  ui: PropTypes.shape({
    customtitle: PropTypes.string,
  }),
  // notifications:PropTypes.shape({
  //   userNotifications:PropTypes.string
  // }),
  app: PropTypes.shape({
    user: PropTypes.shape({
      portfolios: PortfolioSelector.propTypes.portfolios.isRequired,
      selectedPortfolio:
        PortfolioSelector.propTypes.selectedPortfolio.isRequired,
      setSelectedPortfolioId: PropTypes.func.isRequired,
    }),
  }),
};

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.push' },
      replacePage: { $call: 'ui.history.replace' },
      clearData: { $call: 'portfolio.clearData' },
      app: {
        user: {
          portfolios: true,
          // {
          //   $type: 'list',
          //   $range: {
          //     offset: 0,
          //     length: ref('app.user.portfolios.length'),
          //   },
          //   $node: {
          //     id: true,
          //     title: true,
          //     referenceCurrency: true,
          //     relId: true,
          //     relIdType: true,
          //     pfType: true,
          //     branchCode: true,
          //     isPaymentAvailable: true,
          //     isEDeliveryAvailable: true,
          //     isDownloadAvailable: true,
          //   },
          // },
          // entitlement:{
          //   notification:{
          //     read: true,
          //   },
          //   rmcallback:{
          //     read: true,
          //   }
          // },
          selectedPortfolio: true,
          setSelectedPortfolio: { $set: 'selectedPortfolio'},
          setSelectedPortfolioId: {
            $set: 'selectedPortfolioId',
          },
          selectedPortfolioData: true,
          setSelectedPortfolioData: {
            $set: 'selectedPortfolioData',
          },
          setPortfoliosData: {
            $set: 'portfoliosData',
          },
        },
      },
      //WMCE-18515
      portfolio:{
        genericAssets: {
          positions: {
            setPageOffset: { $set: 'pageOffset' },
          }
        }
      },

      auth: {
        entitlement: true,
        passwordExpired: true,
      },
      resetVariables: { $call: 'dashboard.resetVariables'},
      rsa: {
        rsaAuthorised: true,
        onChangePage: { $call: 'changePage' },
      },
      vascoauthentication: {
        vascoAuthorised: true,
      },
      i18n: {
        messages: true,
      },
      userprofile : {
        setPrefCurrency: { $set: 'prefCurrency'}
      },
      ui: {
        setDebug: { $set: 'debug' },
        title: true,
        customtitle: true,
        history: {
          currentLocation: {
            pathname: true,
          },
        },
        toastMsg: true,
        onToastChanged: { $call: 'change.toastMsg' },

        state: {
          portfolio: {
            genericAssets: {
               resetSort: { $call: 'resetSort' },
            }
          },
        },

      },
      setToastMsg: { $set: 'ui.toastMsg' },
      notifications: {
        userNotifications: true,
      },
      search: {
        clearSearchFilters: { $call: 'clearFilters' },
        setPortfolioIds: { $set: 'portfolioIds' },
      },
      callback: {
        screen: true,
        setScreen: { $call: 'setScreen' },
        setPage: { $set: 'pagename' },
      },
      reports: { hideDWOPortfolioSelector: true },
      ais:{
        isBannerVisible: true
      },
      banner: {
        showBeneficiaryBanner: true,
        beneficiaryBannerData: true,
        setShowBeneficiaryBanner: { $set: 'showBeneficiaryBanner' },
      },
      logoutPopup: {
        isVisible: true
      },
      alerts: {
        isAvaloqDown: true
      }
    },
    $renderError: () => null,
  },
  update(['app', 'user', 'portfolios'], filter((p) => p && p.id != null))
)(AppHeader);
